import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Header from "./Components/Header";
import Landing from "./Pages/Landing";
import CompanyList from "./Pages/CompanyList";
import ErrorBoundary from "./Components/ErrorBoundary";

// Nuclear option: Disable ALL transitions globally
const noTransitionsTheme = createTheme({
  transitions: {
    create: () => 'none',
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          transition: 'none !important',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          transition: 'none !important',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          transition: 'none !important',
        },
        track: {
          transition: 'none !important',
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          transition: 'none !important',
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          transition: 'none !important',
        },
      },
    },
  },
});

export default function App() {  

  let t = localStorage.getItem('hitchhiker_token');
  return (    
    <ThemeProvider theme={noTransitionsTheme}>
      <ErrorBoundary>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ErrorBoundary>
            <Header />
          </ErrorBoundary>
          <Routes>
            <Route 
              path="/" 
              element={t ? <Navigate to="/CompanyList" replace /> : <ErrorBoundary><Landing /></ErrorBoundary>} 
            />
            <Route path="/CompanyList" element={<ErrorBoundary><CompanyList /></ErrorBoundary>} />
            <Route path="*" element={<ErrorBoundary><CompanyList /></ErrorBoundary>} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
